
// The hero tagline is picked by the inline script in index.html's <head> so the
// choice lands before the first paint — nothing to do for it here.
const $e73bf42412feb220$var$year = document.getElementById('year');
if ($e73bf42412feb220$var$year) $e73bf42412feb220$var$year.textContent = String(new Date().getFullYear());


//# sourceMappingURL=repo.a47ba4c2.js.map
